import { useHistory, useLocation } from '@atlassian/mpac-ui';
import { useCallback } from 'react';
import { getSelectedFiltersUrl, removeQueryParam } from '../utils/UrlMapUtils';
import { sortQueryParamKey } from './useSort';
export const useSyncQueryParamsWithFilters = _ref => {
  let {
    filterOptions
  } = _ref;
  const history = useHistory();
  const {
    pathname,
    search
  } = useLocation();
  const setQueryParams = useCallback(function (newOptions) {
    let sortKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const mergedQueryString = getSelectedFiltersUrl(filterOptions, newOptions, search || '');
    const mergedParams = new URLSearchParams(mergedQueryString);
    if (sortKey) mergedParams.set(sortQueryParamKey, sortKey);
    history === null || history === void 0 ? void 0 : history.push("".concat(pathname, "?").concat(mergedParams));
  }, [filterOptions, history, pathname, search]);
  const clearFilterFromQueryParam = useCallback(filterId => {
    const newSearch = removeQueryParam(search || '', filterId);
    history === null || history === void 0 ? void 0 : history.push("".concat(pathname, "?").concat(newSearch));
  }, [history, search, pathname]);
  return {
    setQueryParams,
    clearFilterFromQueryParam
  };
};